import {Component, HostListener, Inject, OnInit, Optional} from '@angular/core';
import {IAppState} from '../../store/state/app.state';
import {StoreSelectorsService} from '../../services';
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import * as _ from "lodash";
import {reject} from "lodash";
import {ICopyPaste, IUser} from "../../interfaces";
import {ToastrService} from "ngx-toastr";
import {ImportService} from "../../services/import.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {copyTextClipboard} from "../../common";
import * as xml2js from 'xml2js';

@Component({
  selector: 'app-dialog-clipboard',
  templateUrl: './dialog-clipboard.component.html',
  styleUrls: ['./dialog-clipboard.component.scss']
})
export class DialogClipboardComponent extends Compbaser implements OnInit {

  searchKey = "";
  appData: IAppState;
  filter = "";
  isLoading = false;
  clipboard: string;
  timer;
  titleString = '';
  icon;
  totalSelected = 0;
  importSelected = 0;
  copyData;
  table: 'resources' | 'player_data';
  m_data;
  user: IUser;

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.checkClipboard().then();
  }

  // @HostListener('window:blur', ['$event'])
  // onBlur(event: any): void {
  // }

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) data,
    private storeSelectorsService: StoreSelectorsService,
    private translocoService: TranslocoService,
    private toastr: ToastrService,
    private importService: ImportService) {
    super();

    this.cod(this.storeSelectorsService.getUser().subscribe((user) => {
      this.user = user;
    }));
    if (data) {
      this.m_data = data;
      if (this.m_data.scenes) {
        this.table = 'player_data';
        this.totalSelected = this.m_data.scenes.selected.length;
        this.icon = 'control_camera';
            this.titleString = this.translocoService.translate('general.moveScenesBetweenAccounts', {}, this.translocoService.getActiveLang());
      } else {
        this.table = 'resources';
        this.totalSelected = this.m_data.resources.selected.length;
        this.icon = 'playlist_play';
        this.titleString = this.translocoService.translate('general.moveResourcesBetweenAccounts', {}, this.translocoService.getActiveLang());
      }
    }
  }

  ngOnInit(): void {
    this.checkClipboard().then();
    this.pollClipboard().then();
  }

  async pollClipboard() {
    this.timer = setInterval(async () => {
      await this.checkClipboard();
    }, 3000);
  }

  async checkClipboard() {
    try {
      const clipboard = await navigator.clipboard.readText();
      this.copyData = await this.pasteImportParseData(clipboard);
      if (!this.copyData) return;

    } catch (e) {
    }
  }

  exportClick() {
    if (this.totalSelected === 0) return;
    let buffer = '';
    const mapTable = this.table === 'resources' ? 'resources' : 'scenes';
    /** single item **/
    if (this.m_data[mapTable].selected.length == 1) {
      buffer = `<Business id="${this.user.businessId}" saved="1"><Record table="${this.table}" id="${this.m_data[mapTable].selected[0]}" handle="0"/></Business>`;
      copyTextClipboard(buffer);
      this.checkClipboard().then();
    } else {
      /** multiple items **/
      this.m_data[mapTable].selected.forEach((v) => {
        buffer = buffer + `<Business id="${this.user.businessId}" saved="1"><Record table="${this.table}" id="${v}" handle="0"/></Business>`;
      });
      buffer = `<root>${buffer}</root>`;
      copyTextClipboard(buffer);
      this.checkClipboard().then();
    }
  }

  async importClick() {
    if (this.importSelected === 0) return;
    this.isLoading = true;
    switch (this.table) {
      case "player_data": {
        /** multi import **/
        if (this.copyData.root) {
          for (let i = 0; i < this.copyData.root.Business.length; i++) {
            const scene = this.copyData.root.Business[i];
            const sceneName = 'imported scene ' + _.uniqueId();
            const sceneId = await this.importService.importScene(scene.$.id, scene.Record[0].$.id, sceneName);
            this.toastr.info('new scene created: ' + sceneName);
          }
        } else {
          const sceneName = 'imported scene ' + _.uniqueId();
          const scene = this.copyData.Business;
          if (this.copyData.Business.Record["0"].$.id == '-1'){
              return this.toastr.error('scene was not saved on source so cannot be imported');
          }
          const sceneId = await this.importService.importScene(this.copyData.Business.$.id, this.copyData.Business.Record["0"].$.id, sceneName);
          this.toastr.info('new scene created: ' + sceneName);
        }
        break;
      }
      case "resources": {
        /** multi import **/
        if (this.copyData.root) {
          for (let i = 0; i < this.copyData.root.Business.length; i++) {
            const id = await this.importService.importResource(this.copyData.root.Business[i].$.id, this.copyData.root.Business[i].Record[0].$.id);
            this.toastr.info('new resource created id: ' + id);
          }
        } else {
          const id = await this.importService.importResource(this.copyData.Business.$.id, this.copyData.Business.Record[0].$.id);
          this.toastr.info('new resource created id: ' + id);
        }
        break;
      }
    }
    this.isLoading = false;
  }

  async pasteImportParseData(clipboard): Promise<ICopyPaste> {
    return new Promise(resolve => {
      this.importSelected = 0;
      xml2js.parseString(clipboard, (err, jData) => {
        if (err) {
          return reject(null);
        }
        /** single item copy, resource or scene respectively **/
        if (jData?.Business?.Record[0]?.$?.table && jData?.Business.Record[0].$.table === this.table) {
          this.importSelected = 1;
          return resolve(jData);
        }
        /** multi item copy, resources or scenes respectively **/
        if (jData.root && jData?.root?.Business[0]?.Record[0]?.$?.table && jData?.root?.Business[0].Record[0].$.table === this.table) {
          this.importSelected = jData.root.Business.length;
          return resolve(jData);
        }

      });
    });
  }

  override destroy() {
    super.destroy();
    clearInterval(this.timer);
  }
}

